export const getAppContext = () => window.Odigeo ? window.Odigeo.Settings.getProperty('appContext') : '';
export const trackTime = ({
  key,
  time
}) => fetch(`${getAppContext()}/service/metrics/trackTime`, {
  credentials: 'same-origin',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    key,
    time
  })
});